import React, { Fragment } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import FindStudentsContainer from "../../Component/FindStudents";

const FindStudents = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Bookmarks" />
      <FindStudentsContainer />
    </Fragment>
  );
};
export default FindStudents;
